import { render, staticRenderFns } from "./AdminDocumentSet.vue?vue&type=template&id=7e80214a&scoped=true&"
import script from "./AdminDocumentSet.vue?vue&type=script&lang=js&"
export * from "./AdminDocumentSet.vue?vue&type=script&lang=js&"
import style0 from "./AdminDocumentSet.vue?vue&type=style&index=0&id=7e80214a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e80214a",
  null
  
)

export default component.exports